import { I18n } from "@assets/strings";
import { allCategories, Category } from "@domain/lms/category/category";
import { Set } from "immutable";
import React from "react";
import styled from "styled-components";

interface CategoriesSelectorProps extends React.HTMLAttributes<HTMLDivElement> {
	selected: Set<Category>;
	onSelectionChange: (categories: Set<Category>) => void;
}

export const CategoriesSelector: React.FC<CategoriesSelectorProps> = ({
	selected,
	onSelectionChange,
	...htmlProps
}) => {
	return (
		<Container {...htmlProps}>
			{allCategories.map((cat) => {
				const isSelected = selected.has(cat);
				return (
					<Tag
						key={cat}
						type="button"
						$selected={isSelected}
						aria-pressed={isSelected}
						onClick={() => onSelectionChange(isSelected ? selected.remove(cat) : selected.add(cat))}
					>
						{I18n.t(`category.${cat}`)}
					</Tag>
				);
			})}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 9px;
`;

const Tag = styled.button<{ $selected: boolean }>`
	cursor: pointer;
	border-radius: 999px;
	border: 1.5px solid ${({ $selected }) => ($selected ? "#00863d" : "#e3e7ec")};
	background: ${({ $selected }) => ($selected ? "#e7f4ec" : "#fff")};
	color: ${({ $selected }) => ($selected ? "#00863d" : "#5b6272")};
	font-weight: 600;
	font-size: 13.5px;
	line-height: 1.2;
	padding: 9px 15px;
	font-family: inherit;

	&:hover {
		border-color: #00863d;
	}
`;
